<template>
	<div id="cases">
		<div class="vx-row mt-3 mb-6 flex justify-between">
			<div
				v-if="!is_loading && disabledSubscription && partner?.app_id && partner?.is_live"
				class="border bg-white bg-opacity-20 w-full rounded-lg p-4 mb-6"
				style="border: 1px solid var(--border)"
			>
				<p class="text-danger flex justify-center" :style="{ 'font-weight': 700 }">
					<vs-icon icon-pack="feather" icon="icon-alert-triangle" size="1.4rem" class="mr-3" />
					{{ $t("tooltip payment method") }}
				</p>

				<div v-if="user?.partner_id" class="w-full flex justify-center mt-4">
					<s-button
						icon="icon-credit-card"
						type="danger"
						class="h-10 flex justify-center items-center"
						@click="addPaymentMethod"
					>
						{{ $t("Ajouter un moyen de paiement") }}
					</s-button>
				</div>
			</div>

			<div class="w-full sm:w-1/2 flex justify-center sm:justify-between">
				<h2 class="title-sinao self-center" style="line-height: 35px">{{ $t("Mes partenaires") }}</h2>
			</div>

			<!-- v-if="loadedCases && loadedCases.length >= 8" -->
			<input
				v-model="search"
				type="text"
				:placeholder="$t('Rechercher une entreprise')"
				class="w-full vs-input mt-5 search-input"
			/>

			<div
				v-if="partner && partner?.total_license"
				class="w-fit flex items-center whitespace-no-wrap overflow-x-auto mt-3"
				:style="{ gap: '8px' }"
			>
				<div
					v-for="(license, key, index) in partner.total_license"
					:key="index"
					class="flex items-center bg-white px-2 border text-sm"
					style="line-height: 1.3rem; border-radius: 5px; border: 1px solid var(--border)"
				>
					<span class="mr-1">{{ $t(key) }} : </span>
					<span>{{ license }}</span>
				</div>

				<!-- <div
					v-if="partner.upcoming"
					class="flex items-center bg-white px-2 border ml-4"
					style="line-height: 1.3rem; border-radius: 5px"
				>
					<span class="mr-1">{{ $t("Prochaine échéance") }} : </span>
					<span>{{
						new Date(partner.upcoming.next_payment_date).toLocaleDateString()
					}}</span>
				</div> -->
			</div>

			<div class="w-full border-solid border rounded-lg mt-3 overflow-y-auto" style="border-color: var(--border)">
				<table class="w-full border-collapse border-spacing-0">
					<thead class="text-xs bg-grey-light border-b">
						<tr class="border-spacing-0">
							<th class="flex px-4 pt-2 text-md text-left" style="width: 48px">
								<input
									v-model="select_all_checked_model"
									class="w-5 h-5 cursor-pointer"
									type="checkbox"
									@change="toggleAllCases()"
								/>
							</th>
							<th class="px-4 pt-2 text-md text-left w-200">{{ $t("Nom") }}</th>
							<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Abonnement") }}</th>
							<th class="px-4 pt-2 text-md font-semibold text-center w-200">{{ $t("Collaborateur") }}</th>
							<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Actions") }}</th>
							<th class="px-4 pt-2 text-md font-semibold text-center">{{ $t("Statut") }}</th>
						</tr>

						<tr>
							<th colspan="6">
								<div class="w-full flex pb-2">
									<div
										v-if="selectedCases.length > 0"
										class="flex justify-start items-center mr-8 min-w-fit"
										:style="{ gap: '24px', 'white-space': 'nowrap' }"
									>
										<button
											class="btn-admin text-sm px-2 flex items-center justify-center"
											:class="{ 'pointer-events-none opacity-50': !loadedCollaborators }"
											:style="{ width: 'fit-content', height: '24px' }"
											@click="openModal"
										>
											{{ $t("Affecter un collaborateur") }}
										</button>

										<button
											v-if="user?.partner_id"
											class="btn-admin text-sm px-2 flex items-center justify-center"
											:style="{ width: 'fit-content', height: '24px' }"
											:disabled="
												selectedCases.filter(item => {
													return (
														item.subscription.plan.nickname.toLowerCase() !== 'trial' &&
														!alreadyHaveOtherPlan(item.subscription.plan)
													);
												}).length == 0
											"
											@click="cancelSubscription()"
										>
											{{ $t("Annuler l’abonnement") }}
										</button>

										<button
											v-if="user?.partner_id && !partner?.is_live"
											class="btn-admin text-sm px-2 flex items-center justify-center"
											:style="{ width: 'fit-content', height: '24px' }"
											@click="deleteApps()"
										>
											{{ $t("Supprimer des dossiers") }}
										</button>
									</div>

									<div class="w-fit flex items-center" style="height: 24px"></div>
								</div>
							</th>
						</tr>
					</thead>

					<tbody class="w-full" :class="{ 'opacity-50': is_loading }">
						<tr v-for="(app, index) in loadedCases" :key="index" class="border-b">
							<td class="px-4 flex">
								<div class="flex items-center justify-center" style="height: 40.5px">
									<input
										type="checkbox"
										class="w-5 h-5 cursor-pointer"
										:checked="isAppSelected(app)"
										@change="toggleSelection(app)"
									/>
								</div>
							</td>

							<td class="pr-4 py-1" :style="{ 'max-width': '200px' }">
								<vs-tooltip
									:text="
										'app_id: ' + app.id + ' | admin: ' + app.admin.name + ' | ' + app.admin.email
									"
								>
									<div class="flex items-center">
										<img
											:src="getImageUrl(app.organization)"
											class="rounded-full"
											height="28px"
											width="28px"
											alt="Logo de l'entreprise"
											style="object-fit: contain"
										/>

										<p class="pl-2 text-left text-md truncate">
											{{ app.organization.name }}
										</p>
									</div>
								</vs-tooltip>
							</td>

							<td class="text-center px-4" :style="{ width: '145px' }">
								<vs-tooltip
									v-if="alreadyHaveOtherPlan(app.subscription.plan)"
									:text="$t('tooltip sinao plan')"
								>
									<p class="w-full text-left capitalize">
										{{
											$t(app.subscription.plan.name) ||
											app.subscription.plan.nickname.split("-")[0]
										}}
									</p>
								</vs-tooltip>

								<vs-tooltip
									v-else-if="partner && partner.total_license?.length == 0"
									:text="$t('tooltip no license')"
								>
									<p class="text-left text-grey text-sm italic">
										{{ $t("Aucun abonnement") }}
									</p>
								</vs-tooltip>

								<vs-tooltip
									v-else-if="partner == null && user?.collaborator_partner_id !== null"
									:text="$t('tooltip no license')"
								>
									<p v-if="!app.subscription.is_restricted" class="w-full text-left capitalize">
										{{
											$t(app.subscription.plan.name) ||
											app.subscription.plan.nickname.split("-")[0]
										}}
									</p>
									<p v-else class="text-left text-grey text-sm italic">
										{{ $t("Aucun abonnement") }}
									</p>
								</vs-tooltip>

								<component
									:is="disabledSubscription ? 'vs-tooltip' : 'div'"
									v-else
									:text="disabledSubscription ? $t('tooltip payment method') : undefined"
								>
									<select
										v-model="app.subscription.plan.nickname"
										:disabled="disabledSelectSubscription"
										class="border-solid border rounded-lg py-1 cursor-pointer"
										:style="{ width: '145px', 'border-color': 'var(--border)' }"
										name="choose_plan"
										@focus="previousPlan = app.subscription.plan.nickname"
										@change="confirmPlanChange(app, $event)"
									>
										<option value="" disabled selected>{{ $t("Choisir un abonnement") }}</option>
										<option v-for="(plan, key) in licensePlans" :key="key" :value="key">
											<span>{{ $t(plan.name) || key }}</span>
										</option>
									</select>
								</component>
							</td>

							<td class="text-center px-4">
								<div class="flex justify-center items-center">
									<span
										v-if="getCollaborators(app.policies, loadedCollaborators).length == 0"
										class="text-grey text-sm italic"
									>
										{{ $t("Aucun collaborateur") }}
									</span>

									<template v-else>
										<vs-tooltip
											v-for="(policy, index_policy) in getCollaborators(
												app.policies,
												loadedCollaborators
											)"
											:key="index_policy"
											:color="stringToHSLColor(policy.user.name)"
											:text="`${policy.user.name} – ${$t(policy.policy_profile.name)}`"
										>
											<div
												class="rounded-full shadow-md text-white uppercase text-lg font-medium"
												:style="{
													'background-color': stringToHSLColor(policy.user.name),
													width: '28px',
													height: '28px',
													'margin-left': '-8px',
													'line-height': '28px'
												}"
											>
												{{ policy.user.name.substring(0, 1) }}
											</div>
										</vs-tooltip>
									</template>
								</div>
							</td>

							<td class="text-center px-4">
								<DropdownActionsCases :app="app" />
							</td>

							<td class="flex justify-end px-4">
								<vs-tooltip :text="getTooltip(app.subscription)">
									<div
										class="text-white my-1 status_icon rounded-lg p-2 flex items-center justify-center"
										:class="getStatusColor(app.subscription)"
										style="width: fit-content"
									>
										<vs-icon
											:icon-pack="'feather'"
											:icon="getStatusIcon(app.subscription)"
											size="1.4rem"
										/>
									</div>
								</vs-tooltip>
							</td>
						</tr>

						<tr v-if="loadedCases == null || loadedCases.length == 0">
							<td v-if="is_loading" colspan="6" class="text-center py-4 italic text-grey-light">
								<div ref="cases_loading" class="vs-con-loading__container" />
							</td>

							<td v-else colspan="7" class="text-center py-4 italic text-grey-light">
								{{ $t("Aucun dossier trouvé") }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="mt-4 flex justify-between items-center w-full">
				<select
					v-model="localPageSize"
					class="flex items-center justify-between border px-3 py-2 text-sm"
					:style="{
						width: '70px',
						'border-color': 'var(--border)',
						'background-color': 'transparent',
						'border-radius': '6px !important'
					}"
					name="page_size"
					:disabled="is_loading"
					@change="updatePageSize"
				>
					<option v-for="size in [5, 10, 25]" :key="size" :value="size">
						<span>{{ $t(size) }}</span>
					</option>
				</select>

				<div class="flex items-center justify-end">
					<s-button
						icon=""
						type="border-small"
						class="h-10 flex justify-center items-center text-xs"
						:style="{ 'border-radius': '6px !important' }"
						:disabled="offset === 0 || is_loading"
						@click="previousPage"
					>
						{{ $t("Précédent") }}
					</s-button>

					<s-button
						icon=""
						type="border-small"
						class="h-10 flex justify-center items-center text-xs"
						:style="{ 'border-radius': '6px !important', 'margin-left': '8px !important' }"
						:disabled="offset + localPageSize >= totalRowsLicense || is_loading"
						@click="nextPage"
					>
						{{ $t("Suivant") }}
					</s-button>
				</div>
			</div>
		</div>

		<div v-if="selectedCases.length > 0">
			<ModalAssignCompaniesToCollaborators
				:visible="showModal"
				:apps="selectedCases"
				:filtered-collaborators="getFilteredCollaborators()"
				:partner-id="
					user?.partner_id ??
					user?.collaborator_partner_id ??
					(loadedCollaborators ?? []).find(collaborator => collaborator.user_id === user.id)?.partner_id
				"
				@close="showModal = false"
				@update="updatedCases"
				@update:visible="val => (showModal = val)"
			/>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from "vuex";
	import i18n from "../i18n";
	import debounce from "lodash/debounce";
	import DropdownActionsCases from "../components/DropdownActionsCases.vue";
	import ModalAssignCompaniesToCollaborators from "../components/ModalAssignCompaniesToCollaborators.vue";

	export default {
		name: "Cases",
		components: { DropdownActionsCases, ModalAssignCompaniesToCollaborators },
		data() {
			return {
				is_loading: true,
				showModal: false,
				previousPlan: "",
				search: "",
				lastSearch: "",
				selectedCases: [],
				localPageSize: this.$store.state.pageSize || 10,
				offset: 0,
				debouncedSearch: null,
				abortController: null,
				apps: [],
				SetToggledAllCases: null, // Set object for faster loops
				select_all_checked_model: false // model for select all checkbox
			};
		},
		computed: {
			...mapState([
				"user",
				"loadedApps",
				"loadedCases",
				"licensePlans",
				"partner",
				"pageSize",
				"totalRowsLicense",
				"loadedPolicies",
				"loadedCollaborators"
			]),
			...mapGetters(["getCollaborators", "getImageUrl", "stringToHSLColor"]),
			disabledSubscription() {
				if (this.partner?.is_live == 0) return false;
				return this.partner?.is_live && !this.partner?.is_payment_method;
			},
			disabledSelectSubscription() {
				if (this.partner?.is_live == 0) return false;
				return this.partner?.is_live && !this.partner?.is_payment_method;
			}
		},
		watch: {
			search(newValue) {
				if (newValue === this.lastSearch) return;
				this.lastSearch = newValue;
				this.offset = 0;
				this.debouncedSearch();
			},
			localPageSize: {
				handler(newVal) {
					this.$store.commit("SET_PAGE_SIZE", newVal);
				},
				immediate: true
			},
			loadedCases: {
				handler(newCases) {
					if (newCases && newCases.length > 0) {
						this.is_loading = false;
						if (this.SetToggledAllCases !== null) {
							this.select_all_checked_model = newCases.every(c => this.SetToggledAllCases.has(c.id));
						}
					}
				},
				immediate: true
			}
		},
		created() {
			this.debouncedSearch = debounce(this.fetchPartnerCases, 500);
		},
		async mounted() {
			this.is_loading = true;
			this.debouncedSearch();

			if (!this.partner && this.user?.partner_id !== null)
				await this.$store.dispatch("getPartner", { partnerId: this.user?.partner_id });

			if (this.loadedApps == null && this.user?.partner_id == null)
				this.apps = await this.$store.dispatch("getApps");
			else if (this.loadedApps != null) this.apps = this.loadedApps;

			if (!this.licensePlans && this.user?.partner_id !== null)
				await this.$store.dispatch("getLicensePlans", { partnerId: this.user?.partner_id });

			if (this.loadedPolicies == null && this.partner?.app_id)
				await this.$store.dispatch("getPolicies", this.partner?.app_id);
			else if (
				this.loadedPolicies == null &&
				this.user?.collaborator_partner_id !== null &&
				this.apps?.length > 0
			)
				await this.$store.dispatch("getPolicies", this.apps[0]?.id);

			this.is_loading = false;
		},
		methods: {
			async fetchPartnerCases() {
				this.is_loading = true;

				if (this.abortController) {
					this.abortController.abort();
				}

				this.abortController = new AbortController();
				const { signal } = this.abortController;

				try {
					await this.$store.dispatch("getPartnerCases", {
						partnerId: this.user?.partner_id || this.user?.collaborator_partner_id,
						pageSize: this.localPageSize,
						search: this.search,
						offset: this.offset,
						signal: signal
					});
				} catch (error) {
					if (error.name === "AbortError") {
						console.log("Previous request canceled");
					} else {
						console.error("Error fetching partner cases:", error);
					}
				} finally {
					this.is_loading = false;
				}
			},
			async confirmPlanChange(app, event) {
				const newPlan = event.target.value;

				this.$vs.dialog({
					type: "confirm",
					color: "success",
					title: i18n.t("Changement d’abonnement"),
					text: i18n.t("Êtes-vous certain de vouloir changer d’abonnement ?"),
					accept: async () => {
						try {
							await this.$store.dispatch("updateSubscription", {
								partnerId: this.user?.partner_id,
								app_id: app.id,
								plan_nickname: newPlan
							});

							const new_name_license = this.licensePlans[newPlan]?.name;
							const prev_name_license = this.licensePlans[this.previousPlan]?.name;

							this.$store.commit("UPDATE_TOTAL_LICENSE", {
								newPlan: new_name_license,
								prevPlan: prev_name_license
							});

							this.previousPlan = newPlan;

							this.$vs.notify({
								text: i18n.t("L’abonnement a été mis à jour avec succès"),
								color: "success",
								time: 5000
							});
						} catch (error) {
							this.$vs.notify({
								text: i18n.t("Une erreur s’est produite lors de la mise à jour de l’abonnement"),
								color: "danger",
								time: 5000
							});

							console.error(error);
							window.location.reload();
						}
					},
					cancel: (app.subscription.plan.nickname = this.previousPlan),
					acceptText: i18n.t("Oui"),
					cancelText: i18n.t("Non")
				});
			},
			isAppSelected(app) {
				return this.selectedCases.some(item => item.id === app.id);
			},
			toggleSelection(app) {
				this.showModal = false;
				const isSelected = this.selectedCases.some(item => item.id === app.id);
				if (isSelected) this.selectedCases = this.selectedCases.filter(item => item.id !== app.id);
				else this.selectedCases.push(app);
			},
			toggleAllCases() {
				// offset = 0 never clicked
				if (this.SetToggledAllCases === null) {
					this.SetToggledAllCases = new Set(this.loadedCases.map(item => item.id));
					this.selectedCases = [...this.loadedCases];
				}
				// unselect for this offset
				else if (!this.select_all_checked_model) {
					this.loadedCases.forEach(c => {
						this.SetToggledAllCases.delete(c.id);
						this.selectedCases = this.selectedCases.filter(item => item.id !== c.id);
					});
				} else if (this.select_all_checked_model) {
					this.loadedCases.forEach(c => {
						this.SetToggledAllCases.add(c.id);
						this.selectedCases.push(c);
					});
				}
			},
			async cancelSubscription() {
				const filteredCases = this.selectedCases.filter(item => {
					return (
						item.subscription.plan.nickname.toLowerCase() !== "trial" &&
						!this.alreadyHaveOtherPlan(item.subscription.plan)
					);
				});

				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: i18n.t("Annulation d’abonnement"),
					text: i18n.t("Êtes-vous certain de vouloir annuler ces abonnements ?"),
					accept: async () => {
						try {
							for (const app of filteredCases) {
								await this.$store.dispatch("cancelSubscription", {
									partnerId: this.user?.partner_id,
									app_id: app.id
								});
							}

							if (filteredCases.length > 0) {
								this.$vs.notify({
									text: i18n.t("Les abonnements ont été annulés avec succès"),
									color: "success",
									time: 5000
								});
							}
						} catch (error) {
							this.$vs.notify({
								text: i18n.t("Une erreur s’est produite lors de l’annulation de l’abonnement"),
								color: "danger",
								time: 5000
							});

							console.error(error);
						} finally {
							this.filteredCases.forEach(app => (app.selected = false));
							this.selectedCases = [];
						}
					},
					cancel: () => {},
					acceptText: i18n.t("Oui"),
					cancelText: i18n.t("Non")
				});
			},
			getSubscriptionStatus(subscription) {
				if (!subscription.plan.active || subscription.is_restricted) return "inactive";
				if (subscription.is_trialing || subscription.upcoming_invoice) return "active";
				return "ending";
			},
			getTooltip(subscription) {
				const status = this.getSubscriptionStatus(subscription);
				return {
					active: i18n.t("Abonnement en cours"),
					ending: i18n.t("Abonnement se termine à la prochaine période"),
					inactive: i18n.t("Abonnement inactif")
				}[status];
			},
			getStatusIcon(subscription) {
				const status = this.getSubscriptionStatus(subscription);
				return {
					active: "icon-clock",
					ending: "icon-alert-triangle",
					inactive: "icon-x-circle"
				}[status];
			},
			getStatusColor(subscription) {
				const status = this.getSubscriptionStatus(subscription);
				return {
					active: "bg-primary",
					ending: "bg-warning",
					inactive: "bg-danger"
				}[status];
			},
			getDate(timestamp) {
				const date = new Date(timestamp * 1000);
				return date.toLocaleDateString();
			},
			async addPaymentMethod() {
				const uri = await this.$store.dispatch("addPaymentMethod", { app_id: this.partner.app_id });
				window.location.href = uri;
			},
			alreadyHaveOtherPlan(plan) {
				if (this.licensePlans === null) return false;
				if (plan.nickname.toLowerCase() === "trial") return false;
				if (Object.keys(this.licensePlans).includes(plan.nickname.toLowerCase())) return false;

				return true;
			},
			async updatePageSize(event) {
				const newPageSize = parseInt(event.target.value, 10);
				this.$store.commit("SET_PAGE_SIZE", newPageSize);
				this.offset = 0;
				this.debouncedSearch();
			},
			async previousPage() {
				if (this.offset - this.localPageSize < 0) return;

				this.select_all_checked_model = false;
				this.offset -= this.localPageSize;
				this.debouncedSearch();
			},
			async nextPage() {
				if (this.offset + this.localPageSize >= this.totalRowsLicense) return;

				this.select_all_checked_model = false;
				this.offset += this.localPageSize;
				this.debouncedSearch();
			},
			openModal() {
				this.showModal = true;
			},
			updatedCases() {
				this.showModal = false;
				this.selectedCases = [];
				this.select_all_checked_model = false;
				this.$store.dispatch("getPartnerCases", {
					partnerId: this.user?.partner_id || this.user?.collaborator_partner_id,
					pageSize: this.localPageSize,
					search: this.search,
					offset: this.offset
				});
				this.$store.dispatch("getCollaborators", { partnerId: this.user?.partner_id });
			},
			getFilteredCollaborators() {
				if (this.user?.partner_id == null && this.user?.collaborator_partner_id !== null) {
					return this.loadedCollaborators.filter(collaborator => collaborator.user_id === this.user?.id);
				} else {
					return this.loadedCollaborators;
				}
			},
			deleteApps() {
				if (!this.user?.partner_id) return;
				if (this.selectedCases.length === 0) return;

				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: i18n.t("Supprimer des dossiers"),
					text: i18n.t(
						"Voulez-vous vraiment supprimer les dossiers sélectionnés ? Cette action est irréversible."
					),
					accept: () => {
						this.$store
							.dispatch("deleteApps", {
								partnerId: this.user?.partner_id,
								ids: this.selectedCases.map(app => app.id)
							})
							.then(() => {
								this.$vs.notify({
									text: i18n.t("Les dossiers vont être supprimés dans quelques instants"),
									color: "success",
									time: 5000
								});
								this.selectedCases = [];
								this.fetchPartnerCases();
							})
							.catch(error => {
								this.$vs.notify({
									text: i18n.t("Une erreur s’est produite lors de la suppression des dossiers"),
									color: "danger",
									time: 5000
								});
								console.error(error);
							});
					},
					cancel: () => {},
					acceptText: i18n.t("Oui, supprimer l’accès"),
					cancelText: i18n.t("Non")
				});
			}
		}
	};
</script>

<style scoped>
	.select-input,
	.search-input {
		border-radius: 6px;
	}

	.search-input:focus-within {
		border: 1px solid var(--black);
	}

	.search-input {
		width: 100%;
		margin-bottom: 0px;
		border: 1px solid var(--border);
		padding: 12px;
	}
	.w-200 {
		width: 200px;
	}

	.btn-admin:disabled {
		opacity: 0.5;
		cursor: not-allowed;
		background-color: var(--white);
	}
</style>
